import Paper from "@material-ui/core/Paper";
import { NextFunctionComponent } from "next";
import React from "react";
import { StickyContainer } from "react-sticky";

import { Footer } from "../../../../components/Footer";
import { Topbar } from "../../../../components/Header";
import { LandingName, LandingTitleContextProvider } from "../../../common/context/landingTitle";
import { ProductContextProvider } from "../../context/product";
import { DetailContent } from "../DetailContent";
import { Head } from "./Head";
import { Breadcrumbs } from "./Breadcrumbs";
import { useLandingInput } from "./useLandingInput";

const LandingPage: NextFunctionComponent = () => {
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  const { path, ...productVariables } = useLandingInput();
  return (
    <Paper elevation={0}>
      <Topbar />
      <ProductContextProvider variables={productVariables}>
        <LandingTitleContextProvider landingName={LandingName.ProductDetail}>
          <Head />
          <Breadcrumbs />
          <StickyContainer>
            <DetailContent />
          </StickyContainer>
          <Footer />
        </LandingTitleContextProvider>
      </ProductContextProvider>
    </Paper>
  );
};

export { LandingPage };
